import { useState } from 'react'
import { preloadImage, useAsyncEffect } from 'utils'

export function useImage(source: File | string) {
    const [state, setState] = useState<HTMLImageElement | null>(null)

    useAsyncEffect(async () => {
        if (!source) return

        const url = typeof source === 'string' ? source : URL.createObjectURL(source)
        const img = await preloadImage(url)

        setState(img)

        return () => {
            if (typeof source !== 'string') {
                URL.revokeObjectURL(url)
            }
        }
    }, [source])

    return state
}
